import { render } from "./ImportCSVDataPage.vue?vue&type=template&id=8b978048&scoped=true&ts=true"
import script from "./ImportCSVDataPage.vue?vue&type=script&lang=ts"
export * from "./ImportCSVDataPage.vue?vue&type=script&lang=ts"

import "./ImportCSVDataPage.vue?vue&type=style&index=0&id=8b978048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b978048"]])

export default __exports__